module.exports = __webpack_public_path__ + "img/about-frog.8e941d45.jpg";